import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeModal } from "../../reducers/modalReducer";
import { Modal } from "@allaria-tech/matter/Modal";
import { Typography } from "@allaria-tech/matter/Typography";
import { deleteIndividualDraft } from "../../connectors/connectors";
import { showToastMessage } from "@allaria-tech/matter/ToastMessage";
import {
  deleteDniImages,
  deleteLiveness,
  genericToastifyError,
} from "../../utils";
import { useState } from "react";
import { FormikProps, FormikValues } from "formik";

import { firestoreCollections } from "../../constants";

interface EditDNIModalProps {
  formik: FormikProps<FormikValues>;
}

const EditDNIModal = ({ formik }: EditDNIModalProps) => {
  const [confirmLoading, setConfirmLoading] = useState(false);

  const dispatch = useAppDispatch();
  const { modalName } = useAppSelector((state) => state.modal);
  const { draftUUID } = useAppSelector((state) => state.onboardingData);

  const handleClose = () => dispatch(closeModal());

  const { onboardingType } = useAppSelector((state) => state.activeTemplate);

  const handleConfirm = async () => {
    try {
      setConfirmLoading(true);

      switch (onboardingType) {
        case "ADDITIONAL_COOWNER":
          {
            const { email } = formik.values;
            const uuid = `${draftUUID}-${email}`;
            await deleteDniImages({
              collection: firestoreCollections.dniCoowner,
              uuid,
            });
            await deleteLiveness({
              collection: firestoreCollections.livenessCoowner,
              uuid,
            });
          }
          break;
        case "SIGNATORY":
          {
            const { email } = formik.values;
            const uuid = `${draftUUID}-${email}`;
            await deleteDniImages({
              collection: firestoreCollections.dniSignatory,
              uuid,
            });
            await deleteLiveness({
              collection: firestoreCollections.livenessSignatory,
              uuid,
            });
          }
          break;
        default:
          {
            await deleteIndividualDraft({ draftUUID });
            await deleteLiveness({
              collection: firestoreCollections.liveness,
              uuid: draftUUID,
            });
            await deleteDniImages({
              collection: firestoreCollections.dni,
              uuid: draftUUID,
            });
          }
          break;
      }

      dispatch({ type: "reset-store" });
      formik.resetForm();
    } catch (error) {
      showToastMessage(genericToastifyError, {
        containerId: "layoutPage",
        type: "ERROR",
      });
    } finally {
      setConfirmLoading(false);
    }
  };

  return (
    <Modal
      isOpen={modalName === "modal-edit-dni"}
      onClose={handleClose}
      title="¿Querés editar tu DNI?"
      footerAlignment="right"
      primaryAction={{
        text: "Confirmar",
        onClick: handleConfirm,
        isLoading: confirmLoading,
      }}
      secondaryAction={{
        text: "Cancelar",
        onClick: handleClose,
      }}
    >
      <Typography type="BODY" size="S">
        Para editar tu DNI, deberás corregir tu CUIT / CUIL.
        <br />
        Esto reiniciará el proceso de registro. Asegurate de que realmente
        querés hacerlo antes de continuar.
      </Typography>
    </Modal>
  );
};

export default EditDNIModal;
